/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './css/FlightsDetailsModal.css';
import { ReactComponent as Close } from '../../../images/close-r.svg';
import {
  FLIGHT_TO_INFO,
  FLIGHT_FROM_INFO,
} from '../../../Utils/Constants/GlobalConstants';
import {
  getDepartureTime,
  getDepartyreDay,
  getDepartureAirport,
  getTimeInAir,
  getArrivalTime,
  getArrivalDay,
  getArrivalAirport,
  getDepartureAirportId,
  getArrivalAirportId,
  getFlightCompanyName,
  getTransferTime,
} from '../../../Utils/FlightUtils';
import { ReactComponent as Plain } from '../../../images/plain-r.svg';
import { ReactComponent as Transfer } from '../../../images/transfer-r.svg';

function FlightsDetailsModal(props) {
  const { isVisible, modalNode, handleModalClick, isToDetFlight, flight } =
    props;

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleEscPress = (e) => {
      if (e.key === 'Escape') {
        handleModalClick(false);
      }
    };

    document.addEventListener('keydown', handleEscPress, false);

    return () => {
      document.removeEventListener('keydown', handleEscPress, false);
    };
  }, [isVisible, handleModalClick]);

  const renderFlight = (tripFlights) =>
    tripFlights.map((fl, index) => (
      <div key={index}>
        <div className="flights_det_item">
          <div className="flights_det_item_col1">
            <div className="flights_det_line">
              <div className="flights_det_line_t"></div>
              <div className="flights_det_line_b"></div>
            </div>
            <div className="flights_det_time">
              <div>
                <div className="bm_text_20">{getDepartureTime(fl)}</div>
                <div className="gr_text_12">{getDepartyreDay(fl)}</div>
              </div>
              <div>
                <div className="bm_text_20">{getArrivalTime(fl)}</div>
                <div className="gr_text_12">{getArrivalDay(fl)}</div>
              </div>
            </div>
            <div className="flights_det_port">
              <div>
                <div className="gr_text_14 mb_4">{getDepartureAirport(fl)}</div>
                <div className="bluer_text_12">{getDepartureAirportId(fl)}</div>
              </div>
              <div className="gr_text_14">{getTimeInAir(fl)}</div>
              <div>
                <div className="gr_text_14 mb_4">{getArrivalAirport(fl)}</div>
                <div className="bluer_text_12">{getArrivalAirportId(fl)}</div>
              </div>
            </div>
          </div>
          <div className="flights_det_item_col2">
            <div className="flights_det_info">
              <Plain className="flights_det_ico" />
              <div className="bm_text_20">{fl.number}</div>
            </div>
            <div className="bm_text_16 mb_6">{getFlightCompanyName(fl)}</div>
            {fl.plane && <div className="gr_text_12">{fl.plane}</div>}
          </div>
        </div>

        {index + 1 <= tripFlights.length - 1 && (
          <div className="lights_det_transfer">
            <Transfer className="flights_det_transf_ico" />
            <div className="dbr_text_14">
              {getTransferTime(tripFlights, index)}
            </div>
          </div>
        )}
      </div>
    ));

  const getFlight = () => {
    let result = [];

    if (isToDetFlight) {
      if (flight.forward && flight.forward.length > 0) {
        result = flight.forward;
      }
    } else if (flight.backward && flight.backward.length > 0) {
      result = flight.backward;
    }

    return result;
  };

  return (
    <div
      className={`flights_det_modal_container ${
        isVisible ? 'flights_det_modal_open' : ''
      }`}
    >
      <div
        className="flights_det_modal"
        ref={(node) => {
          modalNode.current = node;
        }}
      >
        <div className="flights_det_modal_title_line">
          <div className="bm_text_26">{`${
            isToDetFlight ? FLIGHT_TO_INFO : FLIGHT_FROM_INFO
          }`}</div>
          <button
            type="button"
            className="flights_close_but"
            onClick={() => {
              handleModalClick(false);
            }}
          >
            <Close />
          </button>
        </div>
        <div className="flights_det_w">{renderFlight(getFlight())}</div>
      </div>
    </div>
  );
}

FlightsDetailsModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  modalNode: PropTypes.instanceOf(Object).isRequired,
  handleModalClick: PropTypes.func.isRequired,
  flight: PropTypes.instanceOf(Object).isRequired,
  isToDetFlight: PropTypes.bool.isRequired,
};

export default FlightsDetailsModal;
